// Copyright (c) Docugami, Inc. All rights reserved.

import { useMsal, useAccount } from "@azure/msal-react"
import { Config } from "config"
import { useEffect, useRef } from "react"
import styled from "styled-components"

const FlowContainer = styled.div`
    width: 100%;
    height: 100%;
    iframe {
        width: 100%;
        height: 100%;
        border: none;
        overflow: hidden;
    }
`

export const PowerAutomateWorkflow = (): JSX.Element => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const widget = useRef<any>();

    useEffect(() => {
        if (!!account) {
            if (widget.current != null) {
                widget.current.notify('closeWidget');
                widget.current = null;
            }

            const sdk = new (window as any).MsFlowSdk({
                hostName: 'https://make.powerautomate.com',
                locale: 'en-US',
                hostId: "Docugami"
            });

            widget.current = sdk.renderWidget('flows', {
                container: 'flowDiv',
                flowsSettings: {
                    searchTerm: 'Docugami'
                },
                templatesSettings: {
                    templateCategory: 'Productivity',
                    searchTerm: 'Docugami',
                    pageSize: 10
                },
            });

            widget.current.listen("GET_ACCESS_TOKEN", async function (requestParam: any, widgetDoneCallback: any) {
                const result = await instance.acquireTokenSilent({
                    account: account,
                    scopes: Config.powerAutomate.auth.scopes,
                });

                widgetDoneCallback(null, {
                    token: result.accessToken
                });
            });

            return () => {
                widget.current?.notify('closeWidget');
                widget.current = null;
            }
        }
    }, [account, instance]);

    return <FlowContainer id="flowDiv" />;
}
